import type { SegmentKind } from '../parsers/types';

export const KIND_LABEL: Record<SegmentKind, string> = {
  audio: 'Audio',
  header: 'Headers',
  metadata: 'Tags',
  image: 'Images',
  index: 'Index',
  padding: 'Padding',
  container: 'Containers',
  unknown: 'Unknown',
};

export const KIND_HELP: Record<SegmentKind, string> = {
  audio: 'The encoded sound itself. These bytes become what you hear.',
  header: 'Describes the stream: sample rate, channels, codec settings. A player reads it first.',
  metadata: 'Human information: title, artist, album, comments.',
  image: 'Pictures such as cover art. They do not affect the sound.',
  index: 'Look-up tables that help a player jump to a time quickly.',
  padding: 'Empty space. It lets an editor change tags without rewriting the whole file.',
  container: 'Wrapper structure that holds other blocks.',
  unknown: 'Bytes that no part of the format explains.',
};

export const KIND_ORDER: SegmentKind[] = ['audio', 'header', 'index', 'metadata', 'image', 'padding', 'container', 'unknown'];
